module.exports = __webpack_public_path__ + "static/media/icon-entregue.112f4871.svg";